import * as yup from 'yup';

export const UserDetailsFormSchema = yup.object().shape({
    firstName: yup.string().max(128).label('First Name'),

    lastName: yup.string().max(128).label('Last Name'),

    email: yup.string().email().max(256).label('Email'),

    jobTitle: yup.string().max(256).label('Job Title'),

    roles: yup
        .array()
        .of(
            yup.object().shape({
                value: yup.string().required(),
                text: yup.string().required(),
            })
        )
        .label('Roles'),

    systems: yup
        .array()
        .of(
            yup.object().shape({
                value: yup.string().required(),
                text: yup.string().required(),
            })
        )
        .label('Systems'),

    legalEntities: yup
        .array()
        .of(
            yup.object().shape({
                value: yup.string().required(),
                text: yup.string().required(),
            })
        )
        .label('Legal Entities'),

    hierarchyNodes: yup
        .array()
        .of(
            yup.object().shape({
                value: yup.string().required(),
                text: yup.string().required(),
            })
        )
        .label('Hierarchy Nodes'),
});
